/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return <footer className="footer" />;
}

export default Footer;
